import localforage from 'localforage'

class Distributeur {
    static getList(){
        return new Promise((resolve, reject) => {
            localforage
                .getItem('listDistributeurs')
                .then(data => { const parsed = JSON.parse(data); resolve(_.sortBy(Array.isArray(parsed) ? parsed : [], ['nom'])) })
                .catch(err => reject(err))
        })
    }

    static async getDistributeur(idDistributeur)
    {
        return new Promise((resolve, reject) => {
            this.getList().then(data => {
                let distributeur = _.find(data, ['id', parseInt(idDistributeur)]);
                resolve(distributeur);
            }).catch(err => reject(err))
        })
    }
}

export default Distributeur



// WEBPACK FOOTER //
// ./src/js/models/Distributeur.js